import NavCaret from '../NavCaret'
import Loader from '../Loader'
import { formatToTimeZone } from '@zenchef/date-fns-timezone'
import { differenceInMonths } from 'date-fns'

const Nav = ({ isLoading, nextMonth, previousMonth, onPreviousClick, onNextClick, className, localeUtils, month }) => {
  const disabled =
    differenceInMonths(
      formatToTimeZone(new Date(), 'YYYY-MM', { timeZone: 'UTC' }),
      formatToTimeZone(month, 'YYYY-MM', { timeZone: 'UTC' })
    ) === 0
  // const months = localeUtils.getMonths()
  // const prev = months[previousMonth.getMonth()]
  // const next = months[nextMonth.getMonth()]
  // const styleLeft = {
  //   float: 'left'
  // }
  // const styleRight = {
  //   float: 'right'
  // }
  return (
    <div className={className}>
      {isLoading && (
        <div className='DayPicker-NavButton' style={{ right: '105px', cursor: 'default' }}>
          <Loader m={'10px'} />
        </div>
      )}
      <>
        <div
          className={`DayPicker-NavButton ${disabled ? 'disabled' : ''}`}
          style={{ marginTop: '5px', right: '52px' }}>
          <NavCaret
            style={{ position: 'relative', top: '-3px' }}
            disabled={disabled}
            direction={'left'}
            onClick={() => !disabled && onPreviousClick()}
          />
        </div>
        <div className='DayPicker-NavButton' style={{ marginTop: '5px', right: '15px' }}>
          <NavCaret style={{ position: 'relative', top: '-3px' }} direction={'right'} onClick={() => onNextClick()} />
        </div>
      </>
    </div>
  )
}

export default Nav
